import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zhanyong1",
  "use": "icon-zhanyong1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zhanyong1\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512z m219.428571-585.142857H292.571429a73.142857 73.142857 0 0 0 0 146.285714h438.857142a73.142857 73.142857 0 0 0 0-146.285714z\" fill=\"#b6b6b6\" p-id=\"8585\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol